<form class="modal-confirmation">
  <div class="modal-header">
    <span class="modal-title"> Confirmation </span>
    <mat-icon (click)="onCancelClick()">close</mat-icon>
  </div>
  <div class="modal-body">
    <span class="icon material-symbols-outlined icon-warning">
      {{data.icon}}
    </span>
    <span class="message-principal">
      {{ data.messagePrimary }}
    </span>
    <span class="message-secondary">
      {{ data.messageSecondary }}
    </span>
  </div>
  <div class="modal-footer">
    <button
      *ngIf="data.showCancel"
      type="button"
      class="btn-cancel text-sm"
      data-bs-dismiss="modal"
      (click)="onCancelClick()"
    >
    {{ data.cancelText }}
    </button>
    <button
      type="button"
      class="btn-save text-sm"
      data-bs-dismiss="modal"
      (click)="onConfirmClick()"
    >
    {{ data.confirmText }}
    </button>
  </div>
</form>
